import type { MaterializedMenuProduct } from '@iheartjane/data-access';
import { SmartSort } from '@iheartjane/dm-sdk';
import { useMemo } from 'react';

export const useMemoizedRowInstance = (
  stringifiedSmartSortInstance: string | undefined
): SmartSort<MaterializedMenuProduct> | undefined => {
  return useMemo(() => {
    if (!stringifiedSmartSortInstance) {
      return undefined;
    }

    return SmartSort.fromJSON<MaterializedMenuProduct>(
      stringifiedSmartSortInstance
    );
  }, [stringifiedSmartSortInstance]);
};
